(function () {
  const productCache = new Map();

  async function getProductData(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const res = await fetch(`/products/${handle}.js`);
    const data = await res.json();
    productCache.set(handle, data);
    return data;
  }

  document.addEventListener('click', async function (e) {
    const swatch = e.target.closest('[data-kk2-swatch]');
    if (swatch) {
      e.preventDefault();
      const card = swatch.closest('kk2-product-card');
      const handle = card.getAttribute('data-product-handle');
      const value = swatch.getAttribute('data-value');

      card.querySelectorAll('[data-kk2-swatch]').forEach((s) => s.classList.remove('is-selected'));
      swatch.classList.add('is-selected');

      try {
        const product = await getProductData(handle);
        const optionIndex = parseInt(swatch.getAttribute('data-option-index'), 10);
        const match = product.variants.find((v) => v.options[optionIndex] === value);
        const img = card.querySelector('[data-kk2-img-main]');
        if (match && match.featured_image && img) {
          img.src = match.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2');
        } else if (product.images && product.images[0] && img) {
          const alt = product.images.find((src) => src.toLowerCase().includes(value.toLowerCase()));
          if (alt) img.src = alt;
        }
        const priceEl = card.querySelector('.kk2-card__price');
        if (match && priceEl) {
          const price = (match.price / 100).toFixed(2);
          priceEl.innerHTML = match.compare_at_price > match.price
            ? `<span class="kk2-card__price--sale">$${price}</span><span class="kk2-card__price--compare">$${(match.compare_at_price / 100).toFixed(2)}</span>`
            : `<span>$${price}</span>`;
        }
      } catch (err) {
        /* silent fail */
      }
      return;
    }

    const qsBtn = e.target.closest('[data-kk2-quickshop]');
    if (qsBtn) {
      e.preventDefault();
      const handle = qsBtn.getAttribute('data-kk2-quickshop');
      if (window.KK2QuickView) {
        window.KK2QuickView.open(handle);
      } else {
        window.location.href = `/products/${handle}`;
      }
      return;
    }
  });
})();
